import { formatDate } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { dateOfBirthComponentLabels, monthsLabels } from 'src/app/app.models';

export interface Option {
  name?: string;
  label?: string;
  value?: any;
}

@Component({
  selector: 'app-expiry-date',
  templateUrl: './expiry-date.component.html',
  styleUrls: ['./expiry-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ExpiryDateComponent),
      multi: true,
    },
  ],
})
export class ExpiryDateComponent implements ControlValueAccessor, OnInit {
  date: any = new Date();
  currentYear = new Date().getFullYear();

  get Date(): any {
    return this.date;
  }
  @Input()
  set Date(value: any) {
    if (value === this.date) return;
    this.date = value;
    this.onChange(this.date);
    this.DateChange.emit(this.date);
    this.setDate();
  }

  @Output()
  public DateChange: EventEmitter<Date> = new EventEmitter<Date>();

  allDates: number[] = [];
  dates: number[] = [];
  months: any = [];
  years: number[] = [];
  thirtyDaysMonths: string[] = ['Apr', 'Jun', 'Sep', 'Nov'];
  enMonths: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  selectedDate: number;
  selectedMonth: number | any;
  selectedYear: number;
  //labels = {};
  private _labels: any;

  @Input() public set labels(labels: any) {
    this._labels = labels;
  }

  public get labels() {
    return this._labels;
  }

  constructor(private cdRef: ChangeDetectorRef) {
    for (let i = 1; i <= 31; i++) {
      this.allDates.push(i);
    }
    for (let i = this.currentYear; i < this.currentYear + 25; i++) {
      this.years.push(i);
    }

    //this.years.reverse();
    this.dates = this.allDates;
  }

  onChange: any = () => {};
  onTouch: any = () => {};
  val = null;

  set controlValue(val: any) {
    this.val = val;
    this.Date = val;
    this.onChange(val);
    this.onTouch(val);
  }
  ngOnInit(): void {
    this.getMonthLabels(this.labels?.months);
  }

  getMonthLabels(months: monthsLabels) {
    for (let [key, value] of Object.entries(months)) {
      this.months.push(value);
    }
  }

  writeValue(value: any) {
    this.controlValue = value;
    this.Date = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  setDate() {
    const date: any = this.date;
    if (date === 'Invalid Date') {
      // console.log('Date is Invalid');
      this.selectedDate = 0;
      this.selectedMonth = 0;
      this.selectedYear = 0;
    } else if (this.date && date != 'Invalid Date') {
      const formatedDate = formatDate(this.date, 'yyyy-MM-dd', 'en');
      const [, year, month, day] =
        formatedDate.toString().match(/^(\d{4})-(\d{2})-(\d{2})/) || [];
      this.selectedDate = +day;
      this.selectedMonth = this.months[+month - 1];
      this.selectedYear = +year;
    }
    this.setDates();
  }

  getMonthNumber(name: string) {
    return this.months.findIndex((month: string) => month === name) + 1;
  }

  isLeapYear() {
    return (
      this.selectedYear % 400 === 0 ||
      (this.selectedYear % 100 !== 0 && this.selectedYear % 4 === 0)
    );
  }

  dateChanged(value: any) {
    let monthNumber = this.getMonthNumber(this.selectedMonth);
    if (this.selectedYear && this.selectedMonth && value) {
      if (this.selectedDate > 0) {
        if (monthNumber < 10) {
          monthNumber = `${'0' + monthNumber}`;
        }
        if (value < 10) {
          value = `${'0' + value}`;
        }
        this.Date = `${this.selectedYear}-${monthNumber}-${value}`;
      }
    }
  }

  setDates() {
    let maxDate = 31;
    // getting the month name in english from months data
    const monthIndex = this.months.findIndex(
      (mon: string) => mon === this.selectedMonth
    );
    const monthVal = monthIndex
      ? this.enMonths[monthIndex]
      : this.selectedMonth;

    if (this.selectedMonth === 2 || this.selectedMonth === this.months[1]) {
      maxDate = this.isLeapYear() ? 29 : 28;
    } else if (this.thirtyDaysMonths.includes(monthVal)) {
      maxDate = 30;
    }
    this.dates = this.allDates.filter((f) => f <= maxDate);
  }

  onValueChange(month: string, year: number) {
    let monthNumber = this.getMonthNumber(this.selectedMonth);
    // getting the month name in english from months data
    const monthIndex = this.months.findIndex((mon: string) => mon === month);
    const monthVal = monthIndex ? this.enMonths[monthIndex] : month;
    let maxDate = 31;
    if (monthNumber === 2) {
      maxDate = this.isLeapYear() ? 29 : 28;
    } else if (this.thirtyDaysMonths.includes(monthVal)) {
      maxDate = 30;
    }
    this.dates = this.allDates.filter((f) => f <= maxDate);
    let dayValue = '';
    if (this.selectedDate > maxDate) {
      this.Date = new Date('');
      this.selectedDate = 0;
      this.cdRef.detectChanges();
    } else if (year && month && this.selectedDate) {
      if (this.selectedDate > 0) {
        if (monthNumber < 10) {
          monthNumber = `${'0' + monthNumber}`;
        }
        if (this.selectedDate < 10) {
          dayValue = `${'0' + this.selectedDate}`;
        } else {
          dayValue = `${this.selectedDate}`;
        }
        this.Date = `${year}-${monthNumber}-${dayValue}`;
      } else {
        this.Date = '';
      }
    }
  }

  monthChanged(name: string) {
    this.onValueChange(name, this.selectedYear);
  }

  yearChanged(value: any) {
    this.onValueChange(this.selectedMonth, value);
  }
}
